<template>
<div v-if="currentPage" :id="currentPage" class="app">
	<div class="app__bg is-left"></div>
	<div class="app__container js-container" :class="{'is-survey': currentPage === 'survey'}">

		<!-- header -->
		<header class="header app__header" :class="{'is-top': currentPage === 'top' || currentPage === 'error'}">
			<div class="inner">
				<div class="header__area">
					<p class="header__logo">
						<img src="/q/assets/img/logo.svg" alt="ラーメン山岡家 YAMAOKA">
					</p>
					<div class="header__progress">
						<template v-if="currentPage != 'completed'">{{ progress }} 回答完了</template>
						<template v-else>回答完了</template>
					</div>
				</div>
			</div>
		</header><!-- ./header -->

		<!-- main -->
		<main class="main app__main">
			<top v-if="currentPage === 'top'" :scheme="scheme" :shopId="shopId" :isYappli="isYappli"></top>
			<survey v-if="currentPage === 'survey'" @progress="setProgress" @submit="submit"></survey>
			<completed v-if="currentPage === 'completed'" :shopId="shopId" :result="postResult" :isYappli="isYappli"></completed>
			<error v-if="currentPage === 'error'" :msg="errorMessage" :errorToHome="errorToHome" :isYappli="isYappli"></error>
			<loading :flag="loadingFlag"></loading>
		</main><!-- ./main -->

		<!-- footer -->
		<footer class="footer app__footer">
			<p class="footer__copyright">© 2020 Maruchiyo Yamaokaya Corporation</p>
		</footer><!-- ./footer -->

	</div>
	<div class="app__bg is-right"></div>
</div>
<loading v-else :flag="true"></loading>
</template>

<script>
import axios from 'axios';

// vue components
import Top from './pages/Top.vue';
import Survey from './pages/Survey.vue';
import Completed from './pages/Completed.vue';
import Error from './pages/Error.vue';
import Loading from './components/Loading.vue';

export default {
	components: {
		Top,
		Survey,
		Completed,
		Error,
		Loading
	},

	data() {
		return {
			published: true, //本番かどうか
			checkLocalStorage: true, //アンケート画面遷移時に重複回答をチェックするかどうか
			url: new URL(window.location.href), //URL
			ua: window.navigator.userAgent, //ユーザーエージェント
			currentPage: '', //現在のページ
			startDate: new Date(), //vueインスタンス作成時点の日付オブジェクト
			progress: '0%', //回答率
			loadingFlag: false, //ローディング画面
			errorMessage: '', //エラーメッセージ
			errorToHome: false, //エラーページから山岡家トップに飛ぶフラグ
			postResult: {}, //POSTしたら返ってくるデータ

			// 最終的にPOSTするデータ
			result: {
				shop: '', //店舗ID
				cid: '', //クライアントID
				ip: '', //IPアドレス
				answer_time: 0, //回答時間（秒）
				soup_rating: 0,
				return_visit: '',
			},
		}
	},

	computed: {
		// 本番かどうかでURLスキームを切り替え
		scheme() {
			if (this.published) return 'yamaokaya:/';
			return 'yappli:/';
		},

		// 店舗ID (URLから取得)
		shopId() {
			const urlArray = this.url.pathname.split('/').filter(Boolean);
			return urlArray[1];
			// return 'cde60763'; //ダミー店舗のID
		},

		// yappliからアクセスしているかどうか
		isYappli() {
            if (this.ua.indexOf('Yappli') < 0) return false;
			return true;
		},

		// アンケート画面かどうか
		isAns() {
			const pathArray = this.url.pathname.split('/').filter(Boolean); //URL配列
			if (pathArray[pathArray.length-1] === 'ans') return true;
			return false;
		}
	},

	methods:{
		// 現在のページを判定
		checkThisPage() {
			const respondent = this.getUuidInStorage(); //ローカルストレージのUUID

			// URLにパラメータがあれば完了画面を表示 (パラメータはphpで取得)
			if (uuid) {
				this.completed(uuid);

			// アンケート画面でないかつユーザーエージェントがyappliの場合、アプリの店舗チェックイン画面に遷移
			} else if (!this.isAns && this.isYappli) {
				location.href = `native:/tab/bio/10537b10`;
			
			// ディレクトリがansであればアンケート画面を表示
			} else if (this.isAns) {
				// ローカルストレージに値があるかどうかチェック (重複回答防止)
				if (respondent && this.checkLocalStorage) {
					// 店舗IDが同じであれば完了画面に遷移
					if (respondent['id'] === this.shopId) {
						this.url.searchParams.set('respondent', respondent['value']); //URLにUUIDをセット
						location.href = this.url; //リロード
					// 店舗IDが違えばエラー画面に遷移
					} else {
						this.errorToHome = true;
						this.error('本日はすでにポイントを獲得済みです。');
					}
				
				} else {
					this.currentPage = 'survey'; //アンケート画面に遷移
					this.setParamToResult(this.shopId, 'shop', true); //店舗IDをセット
					this.setParamToResult(userIP, 'ip', true); //IPアドレスをセット (値はphpで取得)
					this.setParamToResult(cid, 'cid'); //クライアントIDをセット (値はphpで取得)
				}

			// いずれにも該当しなければアンケートトップを表示
			} else {
				this.currentPage = 'top';
			}
		},

		/**
		 * ローカルストレージのUUIDを取得
		 * @return {String}
		 */
		getUuidInStorage() {
			let respondent = localStorage.getItem('respondent');
			if (!respondent) return; //uuidデータがなければ終了

			let respondentData = {};
			respondentData = JSON.parse(respondent);

			// 期限を過ぎていれば終了
			if (this.startDate.getTime() > respondentData['expire']) {
				localStorage.removeItem('respondent'); //ローカルストレージのデータを削除
				return;
			}

			return respondentData;
		},

		/**
		 * 値をresultにセット
		 * 
		 * @param {any} param セットする値
		 * @param {String} to セットする場所 (resultのキー)
		 * @param {Boolean} error paramがfalse型の場合にエラー画面に遷移するかどうか
		*/
		setParamToResult(param, to, error = false) {
			if (!param && !error) return;
			if (!param && error) this.error();
			if (param) this.result[to] = param;
		},

		// 回答率を更新
		setProgress(progress) {
			this.progress = progress;
		},

		// フォームのデータを送信
		submit(survey) {
			this.loadingFlag = true; //ローディング画面表示
			const url = 'https://s.mnkt.me/survey/save'; //送信先URL
			Object.assign(this.result, survey); //子コンポーネントから回答結果を受け取る
			console.log(this.result);

			// 送信
			axios.post(url, this.result).then(res => {
				const uuid = res.data.uuid; //UUID
				this.url.searchParams.set('respondent', uuid); //URLにUUIDをセット
				location.href = this.url; //リロード

			// エラー
			}).catch(error => {
				console.log(error);
				this.loadingFlag = false; //ローディング画面非表示
				this.error(); //エラー画面に遷移
			});
		},

		// 抽選結果の受け取り＆完了画面に遷移
		completed(uuid) {
			this.loadingFlag = true; //ローディング画面を表示
			const url = `https://s.mnkt.me/survey/result/${uuid}`;

			// 送信
			axios.get(url).then(res => {
				this.postResult = res.data; //抽選結果を格納
				this.loadingFlag = false; //ローディング画面非表示
				this.currentPage = 'completed'; //完了画面に遷移
			
			// エラー
			}).catch(error => {
				console.log(error);
				this.loadingFlag = false; //ローディング画面非表示
				this.error(); //エラー画面に遷移
			});
		},

		// エラー画面に遷移
		error(msg = '問題が発生しました。お手数ですが、最初からやり直してください。') {
			this.errorMessage = msg;
			this.currentPage = 'error';
		},
	},

	created() {
		this.checkThisPage();
	},
}
</script>